import { useContext } from 'react'
import { BillingPaymentsHeaderSlotContext } from './BillingPaymentsHeaderSlotContext'

export function useBillingPaymentsHeaderSlot() {
    return useContext(BillingPaymentsHeaderSlotContext)
}
